import React from "react"
import { Link } from "react-router-dom"
import styled from 'styled-components'
import arrow from '../assets/link.png'

const Feedback = () => {
    return (
        <Container>
            <Title>Thank you for testing the prototype.</Title>
            <Text>If you take the time to complete a short survey, it would help us a lot with further development!</Text>
            <StyledLink to="/" >Give Feedback</StyledLink>
            
            <Button to="/">
                <p>Start Prototype again</p>
            </Button>
        </Container>
    );
}

const Container = styled.div`
    width: 90%;
    padding-top: 50px;
    margin: 0 auto;
    text-align: center;
`
const Title = styled.p`
    font-family: ContinentalMedium;
    width: 90%;
    margin: 0 auto;
    font-size: 30px;
    line-height: 38px;
    margin-bottom: 20px;
`
const Text = styled.p`
    font-size: 18px;
    font-height: 24px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 40px;
`
const StyledLink  = styled(Link)`
    font-size: 26px;
    line-height: 32px;
    color: black;
    text-decoration: none;
    &:after {
        background-image: url(${arrow});
        background-size: 7px 13px;
        display: inline-block;
        width: 7px; 
        height: 13px;
        content:"";
        margin-left: 20px;
    }
`;
const Button = styled(Link)`
    width: 250px;
    height: 50px;
    border: 2px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    font-family: ContinentalMedium;
    font-size: 18px;
    letter-spacing: 0.005em;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 50px;
    color: black;
    text-decoration: none;
}
`
export default Feedback;